import { RequiredTheme, ResponsiveValue, system, Theme } from 'styled-system';
import * as CSS from 'csstype';

export const textOverflow = system({
    textOverflow: true,
});

export interface TextOverflowProps<ThemeType extends Theme = RequiredTheme> {
    textOverflow?: ResponsiveValue<CSS.Property.TextOverflow, ThemeType> | undefined;
}
